import React from 'react'
import { AiOutlineClose } from "react-icons/ai";
export class Headers extends React.Component {

    render() {
        const { title, closeBtn ,visibleBtn=false} = this.props
        return (
            <div className='modal-header'>
                <div/>
                <p className='headerTitle'>{title || 'Gửi Tiền'}</p>
                {visibleBtn?<div onClick={closeBtn}><AiOutlineClose /></div>:<div/>}
            </div>
        )
    }
}